/*
 * Abstract class for other path nodes, see SVG specifications ( https://www.w3.org/TR/SVG11/paths.html )
 *  and PIXI.Graphics docs ( http://pixijs.download/dev/docs/PIXI.Graphics.htm )
 */
export class PathElementNode {
    public command: string;
    public x: number;
    public y: number;

    constructor(x: number, y: number) {
        this.x = x;
        this.y = y;
    }

    public draw(graphics: PIXI.Graphics) {
        throw "Method not implemented: draw";
    }

    public clone(): PathElementNode {
        throw "Method not implemented: clone";
    }

    public setInterpolatedTo(from: PathElementNode, to: PathElementNode, ratio: number): void {
        throw "Method not implemented: getInterpolation";
    }

    public equalTo(to: PathElementNode): boolean {
        throw "Method not implemented: equalTo";
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/PathElementNode.ts
 **/